import { Flow } from 'signup-constants/Flow';
export const SoftwareSignups = [Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service, Flow.CmsFree];